import { render, staticRenderFns } from "./PromotionSwiperContainer.vue?vue&type=template&id=b1cd4192&scoped=true"
import script from "./PromotionSwiperContainer.vue?vue&type=script&lang=ts&setup=true"
export * from "./PromotionSwiperContainer.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./PromotionSwiperContainer.vue?vue&type=style&index=0&id=b1cd4192&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1cd4192",
  null
  
)

export default component.exports